import { Form, FormField, PrimaryButton, SecondaryButton } from "common/Forms";
import { CheckboxMultiSelectInput, DateInput, SelectInput, TextInput } from "common/Forms/inputs";
import { Grid, GridCell } from "common/Grid/Grid";
import { ScreenSizes, useScreenSizes } from "common/Grid/useScreenSize";
import { SALES_LEAD_STATUS } from "Constant/Constant";
import { useState } from "react";

const STATUS_OPTIONS = [
  { label: "Cold", value: SALES_LEAD_STATUS.COLD },
  { label: "Warm", value: SALES_LEAD_STATUS.WARM },
  { label: "Hot", value: SALES_LEAD_STATUS.HOT },
  { label: "In Progress", value: SALES_LEAD_STATUS.IN_PROGRESS },
  { label: "Completed", value: SALES_LEAD_STATUS.COMPLETED },
  { label: "Canceled", value: SALES_LEAD_STATUS.CANCELED },
];

export const AdvancedSearchForm = ({ filters, setFilters, userOptions, onApply, onClear }) => {
  const screenSize = useScreenSizes();
  const columns = screenSize === ScreenSizes.Large ? 4 : screenSize === ScreenSizes.Medium ? 2 : 1;
  const [openEndDate, setOpenEndDate] = useState(false);
  const [openStartDate, setOpenStartDate] = useState(false);

  return (
    <Form>
      <Grid columns={columns} classNames={["!gap-x-3 !gap-y-1"]}>
        <GridCell>
          <FormField
            id="search"
            label="Search"
            classNames={["text_input_box"]}
            inputFactory={(id, name) => (
              <TextInput
                id={id}
                name={name}
                placeholder="Search by name, email..."
                value={filters.search}
                onChange={(_, val) => setFilters((prev) => ({ ...prev, search: val }))}
              />
            )}
          />
        </GridCell>

        <GridCell>
          <FormField
            id="filterAssignedTo"
            label="Assigned To"
            inputFactory={(id, name) => (
              <SelectInput
                id={id}
                name={name}
                placeholder="Select users"
                selectedKey={filters.assignedTo}
                optionProvider={() => userOptions}
                keySelector={(x) => x.value}
                labelSelector={(x) => x.label}
                isClearable={true}
                onChange={(_, n) =>
                  setFilters((prev) => ({ ...prev, assignedTo: n ? n.value : "" }))
                }
              />
            )}
          />
        </GridCell>

        <GridCell>
          <FormField
            id="filterStartDate"
            label="Start Date"
            inputFactory={(id, name) => (
              <DateInput
                id={id}
                name={name}
                disabled={false}
                value={filters.startDate}
                placeholder="Select start date"
                open={openStartDate}
                onCalendarClose={() => setOpenStartDate(false)}
                onChange={(_, n) => {
                  const startDate = n ? new Date(n) : undefined;
                  const endDate = filters.endDate ? new Date(filters.endDate) : null;

                  setOpenStartDate(false);
                  if (endDate && startDate && startDate > endDate) {
                    setFilters((prev) => ({ ...prev, startDate, endDate: undefined }));
                    setOpenEndDate(true);
                  } else if (!n) {
                    setFilters((prev) => ({ ...prev, startDate, endDate: undefined }));
                    setOpenEndDate(false);
                  } else {
                    setFilters((prev) => ({ ...prev, startDate }));
                    if (!filters.endDate) {
                      setOpenEndDate(true);
                    } else {
                      setOpenEndDate(false);
                    }
                  }
                }}
              />
            )}
          />
        </GridCell>

        <GridCell>
          <FormField
            id="filterEndDate"
            label="End Date"
            inputFactory={(id, name) => (
              <DateInput
                id={id}
                name={name}
                disabled={false}
                value={filters.endDate || undefined}
                placeholder="Select end date"
                minDate={filters.startDate || undefined}
                open={openEndDate}
                onCalendarClose={() => setOpenEndDate(false)}
                onChange={(_, n) => {
                  const endDate = n ? new Date(n) : undefined;
                  const startDate = filters.startDate ? new Date(filters.startDate) : null;

                  setOpenEndDate(false);
                  if (startDate && endDate && endDate < startDate) {
                    setFilters((prev) => ({ ...prev, endDate, startDate: undefined }));
                  } else {
                    setFilters((prev) => ({ ...prev, endDate }));
                  }

                  if (n && !filters.startDate) {
                    setOpenStartDate(true);
                  } else {
                    setOpenStartDate(false);
                  }
                }}
              />
            )}
          />
        </GridCell>

        <GridCell>
          <FormField
            id="filterStatus"
            label="Status"
            inputFactory={(id, name) => (
              <CheckboxMultiSelectInput
                id={id}
                name={name}
                placeholder="Select status"
                selectedKeys={filters.status}
                optionProvider={() => STATUS_OPTIONS}
                keySelector={(x) => x.value}
                labelSelector={(x) => x.label}
                onChange={(_, next) => setFilters((prev) => ({ ...prev, status: next }))}
              />
            )}
          />
        </GridCell>

        <GridCell column={columns} vertical="bottom">
          <Grid columns={2} columnGap={1}>
            <GridCell>
              <PrimaryButton action={onApply} isWide={true} classNames={["justify-center"]}>
                Apply Filters
              </PrimaryButton>
            </GridCell>
            <GridCell>
              <PrimaryButton action={onClear} isWide={true} classNames={["justify-center"]}>
                Clear Filters
              </PrimaryButton>
            </GridCell>
          </Grid>
        </GridCell>
      </Grid>
    </Form>
  );
};
